/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { forwardRef } from 'react';
import { StyledIconButton, StyledIconButtonLabel, StyledIconButtonContainer } from './index.styles.js';
import { Icon } from '../icon/index.js';
import { ProgressIndicator } from '../progress-indicator/index.js';
import {} from '@oneaudi/unified-web-alpha-common';
import { pickDataProps } from '../../utils/pick-data-props.js';
export const progressIndicatorSize = {
    md: 56,
    sm: 'lg',
    xs: 36
};
export const hasHref = (props) => {
    return typeof props.href === 'string';
};
export const IconButton = forwardRef((props, ref) => {
    const { variant, icon, size, 'aria-label': ariaLabel, className, 'aria-live': ariaLive, id, label, isLoading, title, margin } = props;
    const labelId = `${id}_label`;
    const baseProps = {
        variant,
        ref,
        size,
        'aria-label': ariaLabel,
        title,
        margin,
        id,
        label,
        isLoading
    };
    const content = (React.createElement(React.Fragment, null, isLoading ? (React.createElement(ProgressIndicator, { variant: "spinner", type: "infinite", colorScheme: "idle", size: progressIndicatorSize[size] })) : (React.createElement(Icon, { name: icon, size: props.size === 'xs' ? 'xs' : 's' }))));
    return (React.createElement(StyledIconButtonContainer, { variant: variant, className: className, isLoading: isLoading, margin: margin },
        hasHref(props) ? (React.createElement(StyledIconButton, { ...baseProps, ...pickDataProps(props), as: "a", href: props.href, rel: props.rel, target: props.target, onClick: props.onClick, onKeyDown: props.onKeyDown, "aria-labelledby": label && labelId, "$selected": false }, content)) : (React.createElement(StyledIconButton, { ...baseProps, ...pickDataProps(props), as: "button", "aria-labelledby": label && labelId, "aria-disabled": props.disabled, "aria-controls": props['aria-controls'], "aria-expanded": props['aria-expanded'], "aria-haspopup": props['aria-haspopup'], "aria-live": ariaLive, onClick: props.onClick, onKeyDown: props.onKeyDown, disabled: props.disabled || props.isLoading, type: props.type, "$selected": props.selected }, content)),
        label && (React.createElement(StyledIconButtonLabel, { size: size, id: labelId }, label))));
});
IconButton.displayName = 'IconButton';
//# sourceMappingURL=index.js.map